import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class EmployeePolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'readLeaves':
        return this.permissions.leaves.read

      case 'approveLeaves':
        return this.permissions.leaves.approve

      case 'manageLeavesDocuments':
        return this.permissions.leaves.manage_documents

      case 'manageIncidences':
        return this.permissions.leaves.manage_incidences

      case 'updateLeaves':
        return this.permissions.leaves.update

      case 'terminateEmployee':
        return this.permissions.termination

      case 'editPersonal':
        return this.permissions.personal.edit

      case 'editManager':
        return this.permissions.personal.edit_manager

      case 'shareProfileEmail':
        return this.permissions.profile.email.read

      case 'sharePreferredName':
        return this.permissions.preferred_name.read

      case 'readDocuments':
        return this.permissions.documents.read

      case 'editDocuments':
        return this.permissions.documents.edit

      case 'documents.employeeManageAnyEmployeeFolder':
        return this.permissions.documents.manage_any_employee_folder

      case 'addCustomTablesRecords':
        return this.permissions.custom_tables.create

      case 'removeCustomTablesRecords':
        return this.permissions.custom_tables.remove

      case 'readUserPayrollObservations':
        return this.permissions.payroll_supplements.observations.read

      case 'manageTasks':
        return this.permissions.tasks.read

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default EmployeePolicy
